import React from 'react'
import { Box, Button, makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import colors from '../../assets/colors'

const useStyles = makeStyles({
  tabBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
  },
  tabButton: {
    background: colors.lightGray,
    color: colors.textGray,
    padding: '4px 28px',
    fontWeight: 'normal',
    textTransform: 'capitalize',
    borderRadius: '24px',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      background: colors.primary,
      color: 'white',
    },
  },
  tabButtonActive: {
    background: colors.primary,
    color: 'white',
  },
})

/**
 * TabNav — barra de navegação por abas reutilizável.
 *
 * @param {Array<{ label: string, value: any }>} tabs  - Lista de abas
 * @param {any}      value    - Valor da aba ativa
 * @param {Function} onChange - Callback chamado com o valor da aba clicada
 * @param {object}   [style]  - Estilos extras para o container Box
 */
const TabNav = ({ tabs = [], value, onChange, style }) => {
  const styles = useStyles()

  return (
    <Box className={styles.tabBox} style={style}>
      {tabs.map(tab => (
        <Button
          key={tab.value}
          className={classNames(
            styles.tabButton,
            value === tab.value && styles.tabButtonActive
          )}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
        </Button>
      ))}
    </Box>
  )
}

export default TabNav
